export { SearchBar as default } from './SearchBar';